import { render, staticRenderFns } from "./FamousCommentList.vue?vue&type=template&id=4ee9a596&"
import script from "./FamousCommentList.vue?vue&type=script&lang=js&"
export * from "./FamousCommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports